<script>
const { ...rest } = $props()
</script>

<svg
  id="logo"
  data-name="Layer 2"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 3684.12 974.37"
  aria-hidden="true"
  {...rest}
>
  <defs>
    <style>
    .cls-1 {
      fill: #fff;
    }
    </style>
  </defs>
  <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <path
        class="cls-1"
        d="M478.04,965.79c1.8-.02,8.77-.31,10.85-.35,2.37-.05,5.54-.07,7.91-.12,4.01-.09,6.6,0,10.8.87.36.08,1.34.56,1.69.68.41.14,1.05,1.07,1.05,1.48v.08c0,2.9-2.49,5.38-5.4,5.49-6.88.29-13.79.45-20.77.45-.02,0-.02-.02-.04-.02-1.99-.02-3.74-.02-5.32-.02h-.12c-8.46-.08-17.01-.47-25.37-.97-.16-.04-.41-.13-.57-.35-.08-.11-.15-.27-.1-1.05.04-.63.12-.96.2-1.89h0c.12-1.43,1.32-3.02,2.65-3.55,1.65-.65.81-.14,2.79-.57.24-.05,1.92,0,2.16,0,6.11-.04,6.87-.1,13.68-.1l3.88-.05Z"
      />
      <path
        class="cls-1"
        d="M493.04,950.66c-1.93-3.18.45-8.06,5.33-10.44,3.4-1.59,9.65-2.5,27.92-3.75,29.73-2.04,33.02-1.13,29.17,8.06-2.61,6.24-8.85,8.62-25.99,9.87-26.56,1.82-33.37,1.13-36.43-3.75Z"
      />
      <path
        class="cls-1"
        d="M540.31,971.12c-3.55.42-1.99.3-5.4.61-.1,0-.21.02-.32.02l-5.93.07c-1.17-.53-1.11-.84-1.11-1.76,0-3.23.56-6.39,4.09-6.76,10.19-1.08,14.98-1.67,24.49-2.93,8-1.14,13.5-2.01,20.88-3.39.6-.06,2.79-.67,3.99-.6.49.03.63.44.73.62.88,1.7-1.47,4.79-1.88,5.2-1.13,1.15-1.27,2.49-6.16,3.65l-9.52,1.66c-9.22,1.73-11.5,2.09-20.89,3.24,0,0,1.34-.17,1.32-.17"
      />
      <path
        class="cls-1"
        d="M436.6,970.49c-.08.23-.18.45-.31.66-.1.18-.58.47-.99.62-17.75-1.81-35.3-4.62-52.43-8.32-.18-.02-.28-.21-.26-.39.02-.1.04-.21.08-.31,0-.02.02-.06.04-.08,0-.02.02-.04.02-.08,0-.02.02-.04.02-.06.02-.02.02-.06.04-.1,0-.02.02-.04.02-.06.14-.25.29-.49.45-.72.08-.1.16-.19.23-.27.19-.21.41-.41.64-.6,0,0,.02,0,.02-.02.1-.06.18-.12.25-.18.25-.18.53-.33.8-.49.27-.14.55-.27.84-.41.02,0,.02-.02.04-.02.1-.04.19-.08.29-.12.47-.18.77-.23,1.2-.23,3.67,0,7.21,1.09,10.68,1.69,4.11.7,8.28.97,12.39,1.56,4.19.58,8.4,1.21,12.55,2.03,1.83.37,3.66.8,5.51,1.07.95.14-.36-.09,3.34.59.67.12,1.25.24,1.68.36,2.06.59,3.47,2.11,2.85,3.86Z"
      />
      <path
        class="cls-1"
        d="M467.96,954.29c-1.59.57-12.48,1.02-24.17.79-21.9-.23-23.38-.45-31.32-5.67-3.18-2.16-5.45-8.28-3.97-11.12,1.48-3.06,7.04-3.29,31.1-1.7,24.4,1.59,29.05,2.84,31.44,8.06,1.7,3.75.23,8.4-3.06,9.65Z"
      />
      <path
        class="cls-1"
        d="M361.62,956.34c.57,1.82.91,1.93-17.93-3.63-28.03-8.28-32.57-12.71-6.47-6.36,14.75,3.63,23.49,7.15,24.4,9.99Z"
      />
      <path
        class="cls-1"
        d="M386.82,945.78c-1.82,2.16-6.47,2.04-20.88-.68-14.41-2.72-23.04-5.22-27.58-7.94-4.31-2.61-8.74-9.42-7.83-11.8.68-2.04,6.24-2.27,12.03-.57,2.16.68,8.85,1.93,14.75,2.84,17.48,2.61,26.33,6.47,29.17,12.48,1.48,3.18,1.59,4.2.34,5.67Z"
      />
      <path
        class="cls-1"
        d="M601.87,944.19c-15.89,2.95-22.47,3.75-23.49,2.61-1.36-1.36-1.02-4.77.79-8.28,2.38-4.77,9.65-7.6,28.03-11.12,27.24-5.22,31.55-4.09,22.47,5.79-5.45,5.9-9.87,7.72-27.8,11.01Z"
      />
      <path
        class="cls-1"
        d="M644.2,943.17c-.68,1.93-11.24,6.01-25.99,9.99-13.28,3.63-16.34,4.09-15.21,2.27,1.48-2.5,9.65-5.56,23.83-9.08,8.17-1.93,15.43-3.75,16.23-4.09.91-.23,1.36.11,1.13.91Z"
      />
      <path
        class="cls-1"
        d="M309.19,928.76c-.34.91-1.02,1.7-1.48,1.7-2.27-.11-27.46-8.97-31.55-11.01-6.01-3.06-14.87-12.6-13.28-14.19,1.36-1.36,27.46,6.92,35.86,11.35,6.13,3.4,11.46,9.53,10.44,12.14Z"
      />
      <path
        class="cls-1"
        d="M698.34,911.05c-5.67,6.24-13.62,10.55-27.24,14.75-16.68,5.22-19.18,4.65-13.62-2.61,3.86-4.99,12.94-9.65,29.17-14.98,15.89-5.11,18.38-4.54,11.69,2.84Z"
      />
      <path
        class="cls-1"
        d="M520.05,910.49c-.91,9.99-1.7,11.46-7.6,14.53-4.43,2.5-6.24,2.61-28.6,2.84-13.05.11-24.63,0-25.53-.34-10.89-3.75-11.58-4.2-13.16-7.94-.91-2.04-1.59-7.26-1.59-11.58,0-6.24.45-8.17,2.16-9.76,4.31-3.97,13.28-5.22,36.54-5.22,24.97,0,32.12,1.25,36.2,6.47,2.04,2.72,2.27,3.97,1.59,11.01Z"
      />
      <path
        class="cls-1"
        d="M421.32,922.52c-6.47,2.5-37,0-49.71-3.97-9.31-2.95-13.5-7.26-16.57-17.25-4.31-14.41-1.93-15.32,29.96-11.8,24.74,2.72,28.71,3.75,34.27,8.51,3.29,2.95,4.09,4.65,5.11,10.67,1.59,8.74.68,12.48-3.06,13.85Z"
      />
      <path
        class="cls-1"
        d="M332.8,909.35c-1.93.79-6.47.68-10.1-.11-14.07-3.06-30.41-7.83-34.27-10.1-12.6-7.38-21.79-27.69-12.48-27.69,3.75,0,36.2,7.49,40.86,9.42,7.15,3.06,12.82,9.31,15.43,16.91,2.84,8.4,2.95,10.67.57,11.58Z"
      />
      <path
        class="cls-1"
        d="M683.81,892.67c-5.56,6.13-13.5,9.65-30.87,13.85-16.8,3.97-20.09,4.2-22.13,1.82-1.25-1.48-1.13-2.95.68-8.17,4.77-14.41,9.76-18.16,31.66-23.72,18.16-4.54,27.46-5.45,29.28-2.61,1.48,2.38-3.18,12.82-8.63,18.84Z"
      />
      <path
        class="cls-1"
        d="M240.42,902.2c0,1.25-3.18,1.25-6.24-.11-1.25-.57-4.31-1.59-6.81-2.27-3.29-.79-6.7-3.29-12.37-9.08-4.43-4.31-7.6-8.28-7.15-8.62,2.38-2.38,32.57,16.34,32.57,20.09Z"
      />
      <path
        class="cls-1"
        d="M736.81,899.37c-6.58,3.06-12.94,4.65-12.94,3.06s7.94-8.85,13.05-11.92c6.36-3.86,18.95-9.08,19.75-8.17,1.25,1.25-13.85,14.19-19.86,17.02Z"
      />
      <path
        class="cls-1"
        d="M253.7,885.41c-1.02,2.72-3.4,2.38-16-2.72-18.73-7.6-25.42-12.94-32.46-26.33-4.09-7.72-2.5-8.4,9.65-4.09,14.87,5.22,22.02,8.63,27.12,12.82,5.33,4.31,12.82,17.36,11.69,20.31Z"
      />
      <path
        class="cls-1"
        d="M364.8,863.05c-.45,1.82-2.16,3.52-4.65,4.54-4.65,1.93-6.92,1.82-20.43-.23-35.98-5.56-39.83-8.74-47.21-38.13-1.13-4.65-1.02-5.9.45-8.17,2.72-4.09,8.63-5.67,15.77-4.2,3.29.57,10.89,1.7,16.8,2.38,18.73,2.04,29.51,6.47,33.93,13.73,2.38,3.97,6.36,26.1,5.33,30.07Z"
      />
      <path
        class="cls-1"
        d="M187.08,856.35c0,.79-.34,1.48-.79,1.48-1.7-.11-15.89-8.62-20.65-12.37-5.22-4.2-16.34-19.07-15.32-20.65,1.36-2.27,19.29,7.94,25.65,14.53,4.65,4.88,11.12,14.75,11.12,17.02Z"
      />
      <path
        class="cls-1"
        d="M269.36,847.62c-1.13,1.25-3.4,2.27-4.99,2.27-4.2-.11-27.01-7.04-32.46-9.87-7.38-3.86-13.39-11.24-17.25-21.34-4.88-12.82-5.33-15.77-3.18-18.04,2.61-2.5,4.54-2.38,21.68,2.16,24.85,6.47,29.17,10.44,35.63,33.14,2.61,9.08,2.61,9.42.57,11.69Z"
      />
      <path
        class="cls-1"
        d="M191.62,820.49c0,2.95-2.38,3.29-8.62,1.13-17.25-6.13-24.51-12.26-31.55-26.56-8.85-18.04-8.17-20.2,4.88-15.55,18.73,6.58,24.06,11.35,30.75,27.69,2.5,6.24,4.54,12.14,4.54,13.28Z"
      />
      <path
        class="cls-1"
        d="M127.95,818c-2.95-2.16-12.37-13.62-12.37-14.98,0-2.95,8.51,4.77,13.39,12.03,3.4,4.99,3.06,6.01-1.02,2.95Z"
      />
      <path
        class="cls-1"
        d="M130.34,790.19c0,3.18-1.93,2.84-7.83-1.13-8.85-6.01-14.07-11.92-18.61-21.22-5.11-10.44-6.13-14.41-3.97-14.41,2.84,0,15.21,8.62,18.27,12.71,3.52,4.54,12.14,21.79,12.14,24.06Z"
      />
      <path
        class="cls-1"
        d="M208.3,767.49c-3.06,4.54-4.65,4.54-21.34-.57-21.45-6.47-25.88-11.8-32.8-39.27-2.84-11.35-2.84-15.32-.23-17.7,2.84-2.5,3.75-2.5,19.75,1.48,7.49,1.93,13.96,3.4,14.19,3.4,1.48,0,11.12,10.21,12.71,13.62,1.13,2.16,3.75,11.24,5.79,20.09,3.4,14.98,3.52,16.46,1.93,18.95Z"
      />
      <path
        class="cls-1"
        d="M80.06,754.9c-3.29-3.75-11.01-17.93-11.01-20.2.11-1.82.79-1.48,4.31,2.38,3.97,4.43,8.17,11.8,9.87,17.25.91,2.95-.68,3.29-3.18.57Z"
      />
      <path
        class="cls-1"
        d="M136.01,741.62c0,.11-.79,1.13-1.82,2.04-2.27,2.38-2.04,2.38-11.8-2.27-14.53-6.92-18.73-12.6-24.97-33.37-3.97-13.5-4.09-15.43-1.36-16.91,1.59-.79,4.43-.11,11.46,2.72,15.32,6.13,18.27,10.1,24.51,33.14,2.16,7.94,3.97,14.53,3.97,14.64Z"
      />
      <path
        class="cls-1"
        d="M81.54,714.38c0,3.63-1.82,3.4-8.17-1.25-5.9-4.31-11.24-13.96-15.55-28.26-2.95-9.65-3.06-12.03-.34-12.03,3.06,0,10.89,6.01,13.62,10.44,2.84,4.65,10.44,27.35,10.44,31.1Z"
      />
      <path
        class="cls-1"
        d="M40.68,682.04c-2.72-5.45-9.08-21.34-9.08-22.81,0-.68.79-1.13,1.59-1.13,1.93,0,7.83,11.69,9.76,19.29.68,2.84,1.48,6.01,1.82,7.15,1.13,3.63-1.82,1.93-4.09-2.5Z"
      />
      <path
        class="cls-1"
        d="M146.9,670.01c-2.38,3.63-7.04,3.63-19.18.11-14.64-4.31-18.5-9.87-22.36-31.78-4.31-25.08-2.84-29.96,8.62-28.6,17.59,2.04,23.15,4.88,27.12,13.5,2.61,5.67,5.67,21.79,7.04,36.77.45,5.45.23,7.72-1.25,9.99Z"
      />
      <path
        class="cls-1"
        d="M83.13,650.6c-1.02,2.61-4.77,2.16-11.69-1.36-7.94-3.97-10.67-9.19-14.3-27.58-3.29-16.91-3.4-17.14-.79-20.2,1.82-2.27,2.16-2.38,7.94-.91,10.67,2.84,13.39,7.26,17.25,28.49,2.38,12.94,2.72,18.5,1.59,21.56Z"
      />
      <path
        class="cls-1"
        d="M41.02,630.52c-.68,1.7-1.13,1.7-4.54.11-3.52-1.7-6.47-8.74-9.31-21.56-3.52-16.46-3.18-20.2,2.16-18.5,3.4,1.13,6.24,7.72,8.85,20.43,3.18,15.55,3.52,17.82,2.84,19.52Z"
      />
      <path
        class="cls-1"
        d="M13.1,603.17c-.79.79-2.72-6.13-3.63-13.16-1.13-7.72,1.25-3.4,2.84,5.33.79,3.97,1.13,7.49.79,7.83Z"
      />
      <path
        class="cls-1"
        d="M179.25,573.66c-1.36,2.95-3.52,5.56-5.67,6.58-3.75,1.93-9.65,2.04-22.81.45-11.01-1.36-15.66-3.75-19.86-10.55-3.29-5.33-3.4-6.01-4.43-25.99-.79-18.61-.68-21.11,1.13-26.67,3.4-9.76,5.33-10.67,23.15-10.55,16.57.11,19.97,1.13,24.63,7.94,3.75,5.56,4.99,13.62,5.56,34.73.34,17.02.23,19.63-1.7,24.06Z"
      />
      <path
        class="cls-1"
        d="M100.04,568.67c-1.48,1.59-3.52,2.04-9.87,1.93-9.65,0-11.8-.79-15.77-5.45-4.43-5.33-5.45-10.21-6.13-29.85-.91-26.1,0-28.14,13.28-28.14,16.23,0,19.07,4.43,20.65,32.23,1.13,19.86.68,26.22-2.16,29.28Z"
      />
      <path
        class="cls-1"
        d="M47.04,557.43c-1.13,1.02-2.84,1.93-3.86,1.93-3.86-.11-8.85-3.18-10.21-6.24-2.04-4.43-3.52-17.25-3.63-30.07,0-12.6,1.48-15.89,6.92-15.89,8.97,0,10.89,4.99,11.92,29.73.68,16.68.57,18.73-1.13,20.54Z"
      />
      <path
        class="cls-1"
        d="M15.49,542.45c-.34,5.56-2.27,6.81-4.77,3.06-1.93-2.95-4.09-18.27-4.09-29.05,0-7.72,1.93-10.1,5.33-6.81,1.82,1.93,4.2,23.83,3.52,32.8Z"
      />
      <path
        class="cls-1"
        d="M136.24,433.62c-1.02,22.7-2.61,28.14-8.97,32.34-2.04,1.36-5.9,2.04-13.28,2.38-11.92.34-14.98-.68-18.04-6.58-1.93-3.52-2.04-5.9-1.48-22.81,1.13-30.41,4.2-35.29,23.83-36.88,11.69-1.02,13.96-.23,16.68,5.79,2.04,4.54,2.16,6.36,1.25,25.76Z"
      />
      <path
        class="cls-1"
        d="M25.36,464.71c-2.27,3.4-5.56,3.52-7.94.23-1.48-2.16-1.7-4.77-1.02-15.09,1.02-19.63,4.31-28.14,9.99-25.99,1.02.34,2.16,2.04,2.61,3.63,1.13,4.88-1.59,34.27-3.63,37.22Z"
      />
      <path
        class="cls-1"
        d="M70.98,437.13c-.79,18.61-2.04,24.74-5.45,28.14-1.59,1.59-3.75,2.16-8.97,2.16-9.65,0-10.55-1.59-10.33-19.07.34-28.03,3.29-34.61,16-35.52,8.85-.57,9.65,1.7,8.74,24.29Z"
      />
      <path
        class="cls-1"
        d="M4.03,449.96c-.79,12.48-2.16,17.7-3.75,13.73-.79-2.16.23-18.38,1.48-23.15.34-1.48,1.13-2.61,1.82-2.61.79,0,.91,3.97.45,12.03Z"
      />
      <path
        class="cls-1"
        d="M19.57,387.77c-2.27,3.4-4.99,3.29-4.99-.34,0-3.86,3.06-19.18,5.22-25.76,1.93-6.01,4.43-8.74,6.36-6.81,1.36,1.36-4.09,28.83-6.58,32.91Z"
      />
      <path
        class="cls-1"
        d="M58.27,354.4c-3.4,17.7-5.9,23.38-11.35,25.99-4.2,2.04-7.6,2.5-8.85,1.13-1.36-1.25-.91-7.72,1.48-19.18,3.06-14.75,4.2-18.38,7.72-23.04,3.52-4.65,9.87-7.6,12.26-5.67,2.16,1.82,2.04,3.75-1.25,20.77Z"
      />
      <path
        class="cls-1"
        d="M113.54,328.3c-3.06,21.22-3.75,24.97-6.01,30.3-3.29,7.6-7.38,10.67-16.8,12.82-9.99,2.27-9.87,2.27-12.6-.45-2.95-2.95-2.84-6.24.57-24.74,4.2-23.26,7.49-28.14,22.24-32.68,12.26-3.75,14.75-.79,12.6,14.75Z"
      />
      <path
        class="cls-1"
        d="M189.46,321.04c-2.95,23.49-3.75,26.33-9.42,32.46-5.22,5.67-7.49,6.58-23.95,8.85-15.09,2.27-13.73,2.27-17.36-.91-2.72-2.27-3.18-3.63-3.63-9.87-.57-10.1,3.63-34.84,7.15-41.76,4.88-9.87,8.51-11.8,28.37-16,13.73-2.84,16.8-2.16,19.52,4.2,1.59,3.97,1.59,5.79-.68,23.04Z"
      />
      <path
        class="cls-1"
        d="M56.68,288.35c-4.09,11.92-5.11,14.19-9.53,18.84-1.93,1.93-3.97,3.63-4.43,3.63-3.4,0,6.01-26.9,11.58-32.91,6.47-6.92,7.26-3.86,2.38,10.44Z"
      />
      <path
        class="cls-1"
        d="M104.23,249.54c0,3.29-6.58,23.49-9.76,29.73-2.95,5.9-7.6,9.87-14.98,12.6-2.61,1.13-5.11,1.93-5.45,1.93-1.82,0-1.59-4.65.57-12.71,4.99-18.16,10.78-27.12,20.88-32.57,5.45-2.95,8.74-2.61,8.74,1.02Z"
      />
      <path
        class="cls-1"
        d="M158.14,257.49c-4.2,8.4-8.97,11.69-22.81,15.77-9.31,2.72-11.92,2.95-13.85,1.02-1.93-1.93-1.7-4.43,1.59-17.25,6.01-22.92,10.89-28.71,29.96-35.41,8.97-3.06,13.05-2.95,14.19.57.79,2.61-6.13,29.51-9.08,35.29Z"
      />
      <path
        class="cls-1"
        d="M248.82,219.69c-3.4,17.02-4.99,21.11-9.87,26.22-5.22,5.45-7.72,6.47-23.26,9.76-28.71,6.13-31.1,3.63-24.06-24.74,3.63-14.87,6.92-20.77,13.96-25.42,4.88-3.29,24.4-9.08,33.93-10.1,5.79-.57,6.7-.34,9.31,2.27,3.63,3.63,3.63,4.09,0,22.02Z"
      />
      <path
        class="cls-1"
        d="M101.06,211.86c-4.31,8.97-11.24,17.59-16.23,20.09-5.45,2.84-5.67,2.27-1.7-6.81,4.31-9.53,10.67-18.38,16.34-22.81,8.51-6.47,8.74-5.11,1.59,9.53Z"
      />
      <path
        class="cls-1"
        d="M152.81,185.53c-5.33,10.89-8.85,14.64-20.2,20.77-4.65,2.5-9.76,4.65-11.24,4.65-2.38,0-2.61-.34-1.93-3.52.34-1.93,2.72-7.72,5.33-13.05,5.56-11.35,13.62-19.41,25.31-25.31,12.03-6.13,12.48-3.63,2.72,16.46Z"
      />
      <path
        class="cls-1"
        d="M229.52,142.3c-.23,7.04-7.04,24.06-11.58,29.17-5.11,5.67-10.21,8.28-25.65,13.05-14.07,4.31-14.64,4.31-16.57,2.04-1.82-2.16-.45-7.04,5.22-19.63,4.43-9.65,9.99-16.23,16.8-19.75,7.72-3.97,25.99-10.1,28.94-9.76,2.61.34,2.95.79,2.84,4.88Z"
      />
      <path
        class="cls-1"
        d="M314.87,137.08c-2.27,8.85-3.4,11.24-7.04,15.09-6.47,6.58-10.89,8.4-29.85,12.26-20.31,4.09-25.08,4.31-27.92,1.13-2.61-2.84-1.82-7.94,3.4-21.79,4.54-12.03,8.28-16.57,17.48-20.54,7.6-3.4,30.64-8.74,37.79-8.74,9.99,0,11.01,3.75,6.13,22.58Z"
      />
      <path
        class="cls-1"
        d="M137.49,158.64c-7.72,5.22-8.85,4.65-4.77-2.04,4.88-8.06,21.22-22.24,23.26-20.31,2.04,2.16-10.1,16.8-18.5,22.36Z"
      />
      <path
        class="cls-1"
        d="M833.95,161.25c0,3.4-8.97-2.38-17.14-11.24-5.33-5.67-9.65-12.48-8.62-13.62,2.38-2.27,25.76,20.2,25.76,24.85Z"
      />
      <path
        class="cls-1"
        d="M418.02,119.49c-1.02,15.09-2.04,18.73-6.47,23.04-6.58,6.24-9.99,7.15-33.02,9.53-27.24,2.72-29.96,2.72-34.61-.11-6.13-3.75-6.58-6.24-3.86-19.86,3.06-14.98,5.11-19.29,10.78-22.92,7.04-4.43,12.26-5.79,29.17-7.72,19.97-2.16,26.1-2.16,31.78.11,6.47,2.61,7.15,4.54,6.24,17.93Z"
      />
      <path
        class="cls-1"
        d="M213.29,111.65c-5.33,9.31-11.35,14.64-23.04,20.2-17.82,8.51-19.18,8.17-12.37-2.16,6.13-9.42,13.96-16.34,24.97-21.79,14.3-7.15,16.34-6.47,10.44,3.75Z"
      />
      <path
        class="cls-1"
        d="M789.69,136.62c0,2.38-1.7,2.04-11.01-2.16-16-7.15-22.81-12.94-28.83-24.74-2.61-4.99-2.72-6.58-.57-6.58,3.18,0,22.02,10.33,27.35,14.98,5.67,4.99,13.05,15.43,13.05,18.5Z"
      />
      <path
        class="cls-1"
        d="M279.46,98.6c-5.11,4.43-8.51,5.9-24.74,10.89-12.71,3.97-18.16,4.77-19.41,2.72-.79-1.25,3.63-10.55,7.6-16.23,3.86-5.33,13.39-10.89,26.33-15.09,15.32-4.99,20.43-5.45,20.88-1.93.57,3.63-5.79,15.32-10.67,19.63Z"
      />
      <path
        class="cls-1"
        d="M770.17,100.53c-8.06-4.54-15.66-11.12-13.62-11.92,2.04-.68,13.05,6.24,18.04,11.35,5.11,5.22,4.09,5.45-4.43.57Z"
      />
      <path
        class="cls-1"
        d="M196.04,99.28c-7.38,4.43-10.44,5.11-7.26,1.48,3.06-3.29,15.21-11.24,17.36-11.24,2.72,0-2.61,5.22-10.1,9.76Z"
      />
      <path
        class="cls-1"
        d="M366.5,83.51c-4.77,3.29-8.62,4.31-28.49,7.72-18.5,3.29-24.17,3.52-26.1,1.13-1.82-2.27-.79-7.49,3.18-15.21,4.43-8.74,11.46-12.48,31.21-16.46,17.14-3.4,27.01-3.86,29.17-1.25,3.4,4.2-2.27,19.75-8.97,24.06Z"
      />
      <path
        class="cls-1"
        d="M651.69,93.38c-4.88,1.82-37.22-2.72-48.12-6.81-9.08-3.52-12.82-8.62-15.43-21.56-1.59-8.06,4.65-8.97,28.83-4.31,23.15,4.43,29.39,8.17,34.05,20.31,2.95,7.6,3.18,11.46.68,12.37Z"
      />
      <path
        class="cls-1"
        d="M470.23,63.42c-.79,9.76-2.16,11.69-9.65,15.09-3.97,1.82-8.97,2.5-22.7,3.18-31.21,1.59-34.84,1.36-38.93-3.29-2.04-2.27-2.04-2.72-.23-10.89,3.4-15.43,9.76-18.04,43.92-18.16q22.24-.11,25.31,2.72c2.95,2.72,3.06,3.06,2.27,11.35Z"
      />
      <path
        class="cls-1"
        d="M566.35,77.38c-.23,1.13-1.93,2.72-3.75,3.63-3.4,1.82-14.3,1.93-39.04.57-23.61-1.36-28.14-3.97-29.39-16.8-1.36-13.85,1.82-16.12,22.24-16.12,27.12.11,41.54,3.06,45.74,9.42,2.04,3.29,4.99,16.34,4.2,19.29Z"
      />
      <path
        class="cls-1"
        d="M269.7,64.22c-5.45,5.11-9.31,7.26-24.06,13.28-5.67,2.27-10.89,4.09-11.69,4.09-4.99,0,4.77-10.1,14.98-15.55,7.38-3.86,21.45-9.42,23.95-9.42,2.84,0,1.7,2.84-3.18,7.6Z"
      />
      <path
        class="cls-1"
        d="M731.82,80.45c0,1.93-3.63,1.25-13.5-2.84-14.07-5.79-18.27-8.17-23.61-13.39-4.88-4.65-6.13-7.6-3.4-7.6,1.82,0,19.29,6.92,25.53,10.1,5.11,2.61,14.98,11.69,14.98,13.73Z"
      />
      <path
        class="cls-1"
        d="M299.89,36.75c2.84-2.16,12.48-5.79,17.7-6.7,3.63-.57,3.52-.45-1.7,2.04-3.06,1.59-8.51,3.52-11.92,4.54-5.33,1.48-5.9,1.48-4.09.11Z"
      />
      <path
        class="cls-1"
        d="M346.76,41.75c-3.86,5.9-11.12,9.19-31.21,14.19-8.74,2.27-17.02,4.09-18.27,4.09-6.36,0,1.02-10.67,10.44-15.21,5.67-2.72,34.5-10.89,38.59-10.89,3.29,0,3.52,3.18.45,7.83Z"
      />
      <path
        class="cls-1"
        d="M644.09,29.72c2.16-.79,23.04,6.7,23.04,8.17,0,.68-.45.68-7.38-1.13-7.26-1.7-17.48-6.36-15.66-7.04Z"
      />
      <path
        class="cls-1"
        d="M669.85,59c-1.02,1.82-6.24,1.02-22.02-3.06-20.31-5.33-25.65-7.72-29.62-13.28-7.15-9.87-3.97-10.33,22.81-3.06,7.15,1.93,15.21,4.77,17.93,6.36,4.99,2.95,12.03,11.35,10.89,13.05Z"
      />
      <path
        class="cls-1"
        d="M373.08,20.3c-22.58,4.65-25.76,4.54-19.86-1.02,3.97-3.74,16.51-6.27,23.36-7.72,7-1.48,6.41-1.27,17.21-3.51,1.82-.68,3.34-.12,3,2.15-.57,4.09-6.13,6.47-23.72,10.1Z"
      />
      <path
        class="cls-1"
        d="M429.15,31.42c-2.84,5.67-8.28,7.49-31.44,10.44-22.13,2.72-27.24,2.84-28.94.68-2.95-3.52,3.52-12.26,10.89-14.75,7.04-2.5,43.12-7.04,47.1-6.01,4.09,1.02,4.88,4.43,2.38,9.65Z"
      />
      <path
        class="cls-1"
        d="M595.06,36.41c1.82,3.4,1.93,4.43.68,5.9-1.82,2.27-9.99,2.16-27.92-.11-26.1-3.29-31.1-5.11-33.48-12.26-1.13-3.52-1.13-4.43.68-6.36,2.5-2.72,4.54-2.72,27.12.11,21.45,2.72,29.17,5.67,32.91,12.71Z"
      />
      <path
        class="cls-1"
        d="M614.13,24.16c-.45.34-1.02.68-1.36.57-.34,0-8.85-1.7-18.95-3.75-19.07-3.86-25.76-6.47-26.33-10.67-.45-3.06.52-3.91,6.78-2.19,4.21,1.16,2.27.56,11.5,2.5,6.9,1.45,19.06,4.45,21.22,5.36,4.09,1.7,8.51,6.81,7.15,8.17Z"
      />
      <path
        class="cls-1"
        d="M470.23,8.26c-2.16,2.16-4.99,2.61-25.07,4.09-19.87,1.48-25.09,1.48-25.99,0-.35-.57-.35-2.94.12-5.1.05-.24.09-.47.13-.69.32-1.6,1.61-2.82,3.22-3.02,14.37-1.82,28.94-3.01,43.67-3.54,4-.14,6.78,4.42,4.44,7.66-.15.21-.32.41-.51.6Z"
      />
      <path
        class="cls-1"
        d="M515.62,28.24c.57,3.29.23,4.43-1.7,6.24-2.38,2.16-4.43,2.27-30.53,2.5-32.34.34-35.18-.34-35.29-7.26,0-9.53,6.24-11.69,33.71-11.69s32.23,1.48,33.82,10.21Z"
      />
      <path
        class="cls-1"
        d="M545.85,12.31c-.8,1.25-5.72,1.29-30.11-.19-20.09-1.13-22.48-2.07-23.15-8.05-.37-3.36,1.22-3.71,2.37-3.84h3.24c16.21.33,26.02.78,41.81,2.67l1.49.17c1.44.25,2.45,1.81,3.41,3.82,1.13,2.4,1.39,4.73.94,5.41Z"
      />
    </g>
    <path
      class="cls-1"
      d="M688.4,307.82l210.5,350.94,205.7-350.94h66.94l2.91,2.91v399.41c0,.64-2.57,2.94-1.94,4.85h-49.48v-347.08s-205.65,345.17-205.65,345.17c-3.61,3.24-35.08,3.05-38.81-.04l-206.64-343.17,3.86,345.12h-52.39v-407.17h65Z"
    />
    <path
      class="cls-1"
      d="M1942.83,714.99v-407.17l200.81.02c97.24,8.3,203.95,60.6,210.64,169.54,4.45,72.49.15,133.34-59.33,181.33-99.42,80.21-233.7,50.67-352.12,56.28ZM1995.22,680.09c89.26-3.66,184.96,17.79,258.98-44.65,33.06-27.89,45.4-58.84,47.69-101.64,3.2-59.85-.77-107.06-48.58-147.47-71.5-60.44-171.35-42.78-258.09-45.54v339.31Z"
    />
    <path
      class="cls-1"
      d="M3091.5,714.99l215.69-406.85,47.31-.46,216.27,407.31h-51.42l-60.46-112.15-253.95-.45-59.1,112.6h-54.33ZM3221.51,567.63h219.26l-109.61-209.41-109.65,209.41Z"
    />
    <path
      class="cls-1"
      d="M2332.83,714.99l215.69-406.85,47.31-.46,216.27,407.31h-51.42l-60.46-112.15-253.95-.45-59.1,112.6h-54.33ZM2462.84,567.63h219.26l-109.61-209.41-109.65,209.41Z"
    />
    <path
      class="cls-1"
      d="M1234.61,713.05c-3.2-2.83,10.79-11.72,12.66-13.52,134.19-128.63,265.26-261.81,402.5-386.93,9.21-4.55,21.68-6.12,32.01-6.79,6.14-.4,38.8-.92,40.94,1.91l.58,5.67-205.35,197.05,205.64,202.62h-57.24c-3.93,0-18.47-9.49-22.34-12.58l-161.99-156.07-163.94,158c-3.32,3.14-16.82,10.65-20.39,10.65h-63.06Z"
    />
    <path
      class="cls-1"
      d="M3173,307.82v32.96h-194.03v369.36c0,.64-2.57,2.94-1.94,4.85h-49.48l-2.91-2.91v-371.3h-194.03v-32.96h442.4Z"
    />
    <rect class="cls-1" x="481.76" y="307.82" width="52.39" height="407.17" />
    <path
      class="cls-1"
      d="M1240.82,313.33c-2.77-4.7.81-6.18,4.91-6.9,27.96-4.93,58.38-.22,80.09,17.86,31.81,26.48,60.59,64.3,93.22,91.05,8.26,6.92-17.98,25.88-23.32,27.3-4.24,1.13-8.19,1.44-12.54.8-8.55-1.26-27.65-20.09-35.11-26.98-33.86-31.25-69.26-67.09-101.8-100.01-1.51-1.52-5.17-2.64-5.45-3.12Z"
    />
    <path
      class="cls-1"
      d="M3625.68,230.49c4.71,13.67,8.88,31.38,15.01,44.19.88,1.84,1.59,4.34,3.93,4.74l15.81-48.92h23.69v67.86h-15.79v-47.35l-17.31,46.62-16.66-.85-16.58-44.2v45.77h-15.79v-67.86h23.69Z"
    />
    <polygon
      class="cls-1"
      points="3597.25 230.49 3597.25 243.12 3571.98 243.12 3571.98 298.35 3556.19 298.35 3556.19 243.12 3532.5 243.12 3532.5 230.49 3597.25 230.49"
    />
  </g>
</svg>
